/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Введение в Responsive веб дизайн</h2>
    <p className={styles.description}>
      Раньше сайты были с фиксированной версткой. Если сайт был в ширину 800 пикселей — он так и оставался 800 пикселей,
      на каком мониторе его ни открывай, большом или крохотном. Такой подход полностью устарел вместе с табличной
      версткой.{' '}
    </p>
    <p className={styles.description}>
      Потом сайты стали «резиновыми». Если мы меняли размер окна браузера — элементы сжимались или растягивались.
      Открывали на большом мониторе или на маленьком, или на смартфоне — везде сайт выглядел симпатично, менялся только
      масштаб. Это было удобно пользователю и смотрелось красиво. Но и такой подход тоже устарел.{' '}
    </p>
    <p className={styles.description}>
      Больше половины трафика в интернете приходится на мобильные телефоны и планшеты. Поэтому создание отзывчивых
      веб-сайтов сегодня является обязательным для разработчика интерфейсов.{' '}
    </p>
  </section>
))
